export enum ParameterPolicy {
  //Null means Corp. Default
  DoNotAsk = 0,
  Ask = 1,
  AskAndRequire = 2,
  AskAtShiftStart = 3,
  AskAndRequireAtShiftStart = 4,
  AskAtShiftEnd = 5,
  AskAndRequireAtShiftEnd = 6
}

export const ParameterPolicyMapping: Record<ParameterPolicy, string> = {
  [ParameterPolicy.DoNotAsk]: `Don't Ask`,
  [ParameterPolicy.Ask]: 'Ask',
  [ParameterPolicy.AskAndRequire]: 'Require',
  [ParameterPolicy.AskAtShiftStart]: 'Ask at Shift Start',
  [ParameterPolicy.AskAndRequireAtShiftStart]: 'Require at Shift Start',
  [ParameterPolicy.AskAtShiftEnd]: 'Ask at Shift End',
  [ParameterPolicy.AskAndRequireAtShiftEnd]: 'Require at Shift End'
};

export const ParameterPolicySummaryMapping: Record<ParameterPolicy, string> = {
  [ParameterPolicy.DoNotAsk]: `Disabled`,
  [ParameterPolicy.Ask]: 'Enabled',
  [ParameterPolicy.AskAndRequire]: 'Required',
  [ParameterPolicy.AskAtShiftStart]: 'Enabled (Shift Start)',
  [ParameterPolicy.AskAndRequireAtShiftStart]: 'Required (Shift Start)',
  [ParameterPolicy.AskAtShiftEnd]: 'Enabled (Shift End)',
  [ParameterPolicy.AskAndRequireAtShiftEnd]: 'Required (Shift End)'
};
